(function () {
  var root = document.getElementById('shr');
  if (!root) return;

  var go = root.querySelector('.go');
  var reset = root.querySelector('.reset');

  if (go) {
    go.addEventListener('click', function () {
      var plan = root.querySelector('[name=plan]:checked');
      var chg = root.querySelector('[name=chg]:checked');
      var dev = root.querySelector('[name=dev]:checked');
      if (!plan || !chg || !dev) return;
      root.classList.add('done');
    });
  }

  if (reset) {
    reset.addEventListener('click', function () {
      root.classList.remove('done');
      var inputs = root.querySelectorAll('input[type=radio], input[type=checkbox]');
      for (var i = 0; i < inputs.length; i++) inputs[i].checked = false;
    });
  }
})();
